export type UserData = {
  firstName: string
  lastName: string
  id: string
  email: string
  permissions: string[]
}

export default abstract class Auth {
  abstract init(): Promise<void>
  abstract resolveToken(): Promise<string>
  abstract refreshToken(): Promise<void>
  abstract logout(): Promise<void>
  abstract getUserData(): Promise<UserData>
}
